import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth61: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '17.6 91.8 181.3 91 184.6 95.6 186.6 109.1 185.5 120.1 182.4 124.3 22.3 124.3 19.2 122 17.2 119.1 15.6 114.6 15.1 110.2 14.8 97.9 17.6 91.8',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M35.2,130.6l-8.7-3.4-7.6-5.4-1.6-2.7-1.9-4.9-.2-4.1-.3-12.3,2.8-6.1,2.1-4.2,1.8-4.4s54.1,20.2,13.6,47.4h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M171.8,78.3l4.8,4.6,4.3,5.7,2,3,1.8,3.9,1.8,7.5.2,6,.4,4.7-.9,5.4-3.6,5.1-3.4,4.6-2.9,1.6s-56.1-20.7-4.5-52.1h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M15.7,113.1s92-25.5,170.9,0l-.5-7.5-.7-7-2.1-5.2-3.6-6.8-9.6-10.7-8-7.7-9.8-7.3-13.2-7.3-11.1-4.8-12.9-3.2-7.9-1.2-7.5-1.1-11.6-.2-12.3.2-8.6.9-11.1,3.4-10.2,5.9-9.1,7.9-7.9,7.1-5.4,7.9-4.6,10.2-3.4,10.5',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M69.2,82.4h54.1s-31.1-73-54.1,0Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M186.6,113.1l-1.7,9.8-7.6,8.2-9.6,5.8-14.8,8.2-5.6,5.2-11.7,7.6-11.1,6.2-11.3,4.1-11.6-.4-14-4.4-12.2-5.4-10.9-7.6-9.7-8.3-7.4-5.3-7.9-3.7-13.5-5.3-6.2-4.1-1.9-2.9-2.1-5.4v-2.3s91.5-25.4,170.9,0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M124.2,163.5c-10.7,5.3-21.1,5.1-31.8,1.2-13.8-5.1-26.2-11.9-36.7-22.3-12.2-12-30.5-12.3-36.3-20.7-10.3-14.8-.5-43.5,13.9-57.4,20.9-20.2,36.1-22.5,64.7-21.1,32.7,1.5,60.4,16.9,80.6,42.1,11.4,14.2,12.2,38.6-5.9,48.5l-16,8.8c-10.4,7.7-20.5,15-32.5,20.9Z',
			},
		},
	},
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.4,52.1l-.2,17.9,1.3,19.5s55-27.5-1.1-37.4Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M180.1,54.7l1.7,16.4-.5,19.4s-50.3-23-1.2-35.8Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '27.2 42.9 174.7 42.9 169.4 36.2 164.4 31.2 160.6 27.4 155 23.6 150.4 21.6 144.1 19.7 138.6 19.2 133.6 18.4 118.9 18.4 111.1 17.1 101 15.7 93.1 14.2 80.7 13.8 61.8 13.8 49.5 15.5 42.1 17.4 34.6 20.3 30.2 26.4 27.6 32.9 27 38.3 27.2 42.9',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M88.8,105.4A14,14 0 0 1 116.8,105.4A14,14 0 0 1 88.8,105.4Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M42.5,138l-8-14.3-3.4-12.8-2.5-16.2v-5.2l-1.5-14.9.4-22.5-.2-9.3v-8.2l3.4-9.6,4-4.8,11.3-3.8,7.8-1.7,6.7-.8,10.5-.4,7.6.2s10.5,67.8-36.1,124.2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M128.1,18.4h9.6l6.5,1.3,10.1,3.1,5.4,3.4,4.8,5,4.8,4.2,5.2,6.7,3.8,7.3,1.9,5.4,1.5,6.3.4,6.7.4,8.2-.2,7.1-1.3,11.1-1.9,11.5-2.9,9.4-4.2,10.9-3.8,7.5-6.1,6.7s-44-46.4-33.8-121.5Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M42.5,138s59.4,39.4,119.4,1.9l-6.1,14.7s-48,31.5-109.1-2.3l-4.2-14.3Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.6,32.9l3.1-7.8,4.6-5.7,10.7-3.6,7.8-1,12.4-1.3,8.4-.2,9.4.4,7.3.6,6.7.6,7.3,1.3,5.9,1,7.8,1.3,10.7-.6,9,.4,8.8,2.3,7.6,3.1,4.6,2.7,5.9,4.6,4.8,5,3.8,5.2,4,7.3,3.2,9.4,1.1,7.1.4,13-.4,7.1-1.7,10.7-1.3,8.2-2.7,9.6-3.4,9.2-3.1,8-4.8,5.7-3.6,3.8s-51.4,38-119.4-1.9l-7.3-12-3.8-14-1.7-8-1-8-.8-10.1-.8-8.2v-9.2l-.6-9v-10.1l.4-11.1.6-5.4Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M174.4,118.6c-7.7,20.4-19.3,28.1-40,36.6-33.4,13.7-69.3,2.8-94.9-21.6-4.9-8.9-7.7-17.9-9-28-3-23.8-4.4-47.6-2.4-71.3s6.8-15.3,15.3-16.8c17.5-3.2,35.1-4.7,52.8-2.3s25.7,3.7,38.9,3.8,23.8,5.4,32.3,14.7,12.7,16.1,13.9,27.1c2,19.4.1,39.3-6.8,57.8Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M72.5,410l73.7-.7s-40.3-130.6-73.7.7Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M185.2,448.6l3.4-11.7.7-12.7-1-7.9s-57.9,10.7-3.1,32.4Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27,420v34.8s61.3-24.1,0-34.8Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '27.7 464.8 175.9 464.8 169.9 472.1 161.7 479.2 153.5 482.7 141.7 484.9 133.7 485.4 125.6 487.1 117.6 488.5 109 490.6 100.2 491.9 95.2 492.5 68.3 492.6 54.4 491.1 41.9 488.6 34.8 484 30 477.6 27.8 471.4 27.7 464.8',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M42.5,355.1s56.7-55.4,131.8,2l-10.1-19.7s-59.5-42.9-116.9,1.5l-4.8,16.2Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M79.7,492.7h-11.5s-13.9-1.6-13.9-1.6l-12.5-2.5-7.1-4.6-4.7-6.4-2.3-6.2-.8-16.6v-34.8l.4-15.8,3-22.1,12-27s44.5,65.8,37.3,137.6Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M174.3,357.1l6.4,14,2.4,10.1,2.2,10.4,1.4,7.9,1.6,9.4v7.3s.4,20.7.4,20.7l-3.4,11.7-5.9,12.1-3.4,4.1-7.3,9.1-6.9,5.4-8.8,3.8-9.9,2s-4.9-82.2,31.4-128Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M42.5,355.1s56.2-56.2,131.8,2l6.4,14,7.6,37.8,1.1,20.1-.8,7.9-3.4,11.7-5.2,10.7-11.4,14.6-7.6,5.7-8.1,3.4-9.9,2-9.8.3-24.2,5.3-14.3,2.1h-27.1c0-.1-13.2-1.7-13.2-1.7l-12.9-2.6-6.4-4.1-5-6.9-2.3-6.2-.9-31.3.2-20.7v-15.7c-.1,0,3.4-21.5,3.4-21.5l4.8-13.6,7.2-13.4Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M145.1,484.1c-36.6,4.1-49.4,13.9-97.8,5.7s-18.3-10.4-19.3-21.9c-1.9-22.9-1.4-45.6.3-68.7s5-28.8,13.2-41.7l3.1-9.7c38.7-25.4,84.1-26.5,123.4-1.7,8.9,12.9,14.4,27.2,17,42.8s4,28.9,3.1,43.4c-1.5,24.5-18.4,49.1-43.1,51.8Z',
			},
		},
	},
};
